export default {
  road_book: {
    // Enum的属性
    road_book_item: {
      entrance: '目的地线路图',
      charging_pile_guidance: '充电桩指引',
      charging_pile_position: '充电桩位置',
      service_center: '服务站',
      peripheral_facilities: '周边设施',
      toilet: '洗手间',
      convenience_store: '便利店',
      simple_meals: '简餐',
      lounge: '休息室',
      hotel: '酒店'
    },
    tags: {
      destination: '目的地',
      charging_pile: '充电桩',
      location: '位置'
    }
  }
}
